import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
  ViewChild,
} from '@angular/core';
import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  MatTooltip,
} from '@angular/material/tooltip';
import { DirectiveSuperclass } from '@sama/ng-core';
import { timer } from 'rxjs';
import { BrowserControlService } from '../../../../cross-team-shared/misc-services/browser-control.service';
import { DebugLoggingService } from '../debug-logging.service';

const TOOLTIP_DELAY = 2000;

@Component({
  selector: 'h3-debug-log-id',
  templateUrl: './debug-log-id.component.html',
  styleUrls: ['./debug-log-id.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
      useValue: { hideDelay: TOOLTIP_DELAY },
    },
  ],
  standalone: false,
})
export class DebugLogIdComponent extends DirectiveSuperclass {
  @ViewChild('tooltip') private tooltip!: MatTooltip;

  logId: string;

  private browserControlService = inject(BrowserControlService);
  private debugLoggingService = inject(DebugLoggingService);

  constructor(injector: Injector) {
    super(injector);
    this.logId = this.debugLoggingService.logId;
  }

  async copyAndShowTooltip() {
    await this.browserControlService.writeClipboardText(this.logId);

    this.tooltip.disabled = false;
    this.tooltip.show();
    this.subscribeTo(timer(TOOLTIP_DELAY), () => {
      this.tooltip.hide();
      this.tooltip.disabled = true;
    });
  }
}
